var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
var DEFAULT_LANGUAGE_CONFIG = {
    availableLanguages: ["en"],
    defaultLocale: "en",
};
var normalizeLanguageConfig = function (availableLanguages, defaultLocale) {
    var normalizedDefault = (defaultLocale === null || defaultLocale === void 0 ? void 0 : defaultLocale.trim()) || "en";
    var languages = Array.from(new Set((availableLanguages !== null && availableLanguages !== void 0 ? availableLanguages : [])
        .map(function (language) { return language.trim(); })
        .filter(function (language) { return language.length > 0; })));
    if (languages.length === 0) {
        languages.push(normalizedDefault);
    }
    return {
        availableLanguages: languages,
        defaultLocale: normalizedDefault,
    };
};
var ResultsManifestContext = createContext(__assign(__assign({}, DEFAULT_LANGUAGE_CONFIG), { setManifestLanguageConfig: function () { return undefined; }, resetManifestLanguageConfig: function () { return undefined; } }));
export var ResultsManifestContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(DEFAULT_LANGUAGE_CONFIG), languageConfig = _b[0], setLanguageConfig = _b[1];
    var setManifestLanguageConfig = useCallback(function (manifest) {
        return setLanguageConfig(normalizeLanguageConfig(manifest === null || manifest === void 0 ? void 0 : manifest.available_languages, manifest === null || manifest === void 0 ? void 0 : manifest.default_locale));
    }, []);
    var resetManifestLanguageConfig = useCallback(function () { return setLanguageConfig(DEFAULT_LANGUAGE_CONFIG); }, []);
    var value = useMemo(function () { return (__assign(__assign({}, languageConfig), { setManifestLanguageConfig: setManifestLanguageConfig, resetManifestLanguageConfig: resetManifestLanguageConfig })); }, [languageConfig, setManifestLanguageConfig, resetManifestLanguageConfig]);
    return (_jsx(ResultsManifestContext.Provider, { value: value, children: children }));
};
export var useResultsManifest = function () { return useContext(ResultsManifestContext); };
